"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(require("./Modal"));

var _ModalManager = _interopRequireDefault(require("./ModalManager"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Modal/index.js
// module id = 88
// module chunks = 0